module.exports = __webpack_public_path__ + "media/server_informations.79cb1f4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cloud/server/server_informations.png
// module id = 740
// module chunks = 2